import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useOrganizersLogoutMutation } from '../../Api/organizers';
import { useGlobalState } from '../../App/globalState';
import { ReactComponent as ArmenianFlag } from '../../Assets/armenian-flag.svg';
import { ReactComponent as UKFlag } from '../../Assets/UK-flag.svg';
import { ReactComponent as SignInIcon } from '../../Assets/user.svg';
import useLogout from '../../Hooks/useLogout';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Dropdown from '../../Style-guide/Dropdown';
import Modal from '../../Style-guide/Modal';
import OrganizerHeaderWrapper from './styles/organizerHeaderWrapper';

const OrganizerHeader = () => {
  const [showModal, setShowModal] = useState(false);
  const { mutate: logoutRequest } = useOrganizersLogoutMutation();
  const logout = useLogout();
  const { courtId } = useParams();
  const { globalState, updateGlobalState } = useGlobalState();
  const { hasMultipleCourts } = globalState.organizer || {};
  const { language } = globalState || {};
  const tr = useTranslate();

  const handleLanguageChange = () =>
    updateGlobalState({
      language: language === 'en' ? 'hy' : 'en',
    });

  return (
    <OrganizerHeaderWrapper $language={language}>
      <div className='dropdown-container'>
        <Button
          type='icon'
          className={`language-flag-icon-btn ${language === 'en' ? 'spin' : ''}`}
          onClick={handleLanguageChange}
          icon={language === 'en' ? <UKFlag /> : <ArmenianFlag />}
        />
        <Dropdown
          parent={<SignInIcon className='account-icon' />}
          items={[
            <Link to={`/organizers/account/${courtId}`}>{tr('account')}</Link>,
            <Link to={`/organizers/court/${courtId}`}>{tr('court')}</Link>,
            hasMultipleCourts && (
              <Link to='/organizers/select-court'>{tr('select_court')}</Link>
            ),
            <Link to={`/organizers/reservations/${courtId}`}>{tr('reservations')}</Link>,
            <Button onClick={() => setShowModal(true)}>{tr('log_out')}</Button>,
          ].filter(Boolean)}
        />
      </div>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        confirmation
        question={tr('are_you_sure')}
        confirmText={tr('log_out')}
        cancelText={tr('cancel')}
        onConfirm={() =>
          logout({
            redirectPath: '/organizers',
            logoutRequest,
            globalStateKey: 'organizer',
          })
        }
      />
    </OrganizerHeaderWrapper>
  );
};

export default OrganizerHeader;
